import { Component, OnInit, OnDestroy, Input, SimpleChanges } from '@angular/core';
import { UserService } from '../../../../../auth/user.service';
import { SiteDashboardService } from '../../../site-dashboard.service';
import { PlinksDashboardService } from '../plinks-dashboard.service';

@Component({
	selector: 'app-plink-faults',
	templateUrl: './plink-faults.component.html',
	styleUrls: ['./plink-faults.component.css']
})
export class PlinkFaultsComponent implements OnInit,  OnDestroy {

	@Input() plink: any = {};
	@Input() customerID: number = 0;
	@Input() siteID: number = 0;
	@Input() hasPlinks = false;
	@Input() dateRange: {
		'fromDateFmt': Date,
		'toDateFmt': Date
	};
	@Input() tab = 'faults';
	@Input() sitePlinksData: any = {};
	@Input() siteTags: any = {};
	@Input() sitePlinksTags: any = {};
	@Input() customerName: string = '';
	@Input() siteName: string = '';
	settings: any = {
		height: '500'
	}

	plinkID: number = 0;
	PlinkData: any = {};
	currentUser: any = {};
	prevToDate: any;
	prevFromDate: any;
	isLoading: boolean = true;

	// Grid configurations
	FaultsGridColumns = [];
	FaultsGridData: any = [];

	eventsLoading: boolean = false;
	selectedTimePeriod: string = 'W'; // Default to Last Week

	intervalID: any;

	constructor(
		private userService: UserService,
		private siteDashboardService: SiteDashboardService,
		private plinksDashboard: PlinksDashboardService,
	) { }

	ngOnInit() {
		this.currentUser = this.userService.getCurrentUser();
		this.siteDashboardService.setActiveSubTab('plink-analytics');

		// Reset data
		this.resetPlinkData();

		// Initialize Fault Columns
		this.initializeGridColumns();

		//Set PlinkId
		this.plinkID = this.plink.deviceid;

		// Get Fault Data
		this.getFaultsData();

	}


	initializeGridColumns() {
		// Faults grid columns
		this.FaultsGridColumns = [
			{headerName: 'Time', field: 'timeFormatted', flex: 1},
			{headerName: 'Description', field: 'faultDescription', 
				flex:1,  floatingFilterComponent: "dropDownFilterComponent", filter: 'agTextColumnFilter', floatingFilter: true, floatingFilterComponentParams: {filterOptionType: 'contains', dropDownOptions: [{label: '', value: ''},{label: 'Fault Latching', value: 'Fault Latching'}, {label: 'Fault Non-Latching', value: 'Fault Non-Latching'}, {label: 'Over Voltage', value: 'Over Voltage'}, {label: 'Under Voltage', value: 'Under Voltage'}, {label: 'Over Current', value: 'Over Current'}, {label: 'Under Current', value: 'Under Current'}, {label: 'Over Frequency', value: 'Over Frequency'}, {label: 'Under Frequency', value: 'Under Frequency'}, {label: 'Fault Relay Aux Bad', value: 'Fault Relay Aux Bad'}]}},
		];

	}

	resetPlinkData() {
		this.PlinkData = {
			fromDate: 0,
			toDate: 0,
			fromDateFmt: null,
			toDateFmt: null,
			lastFaultID: 0,
			faultsMinDate: 0
		};

		this.FaultsGridData = [];
	}

	filterPlinkData() {
		if(!this.plink || !this.plink.deviceid) {
			return;
		}

		this.plinkID = this.plink.deviceid;

		// Set date range
		if(this.dateRange && this.dateRange.fromDateFmt && this.dateRange.toDateFmt) {
			this.PlinkData.fromDate = Math.floor(this.dateRange.fromDateFmt.getTime() / 1000);
			this.PlinkData.toDate = Math.floor(this.dateRange.toDateFmt.getTime() / 1000);
			this.PlinkData.fromDateFmt = this.dateRange.fromDateFmt;
			this.PlinkData.toDateFmt = this.dateRange.toDateFmt;
		}
	}

	getFaultsData(){
		let plinkID = this.plinkID;
		// let toDate = this.PlinkData.faultsMinDate;
		// let lastID = this.PlinkData.lastFaultID;

		var faultsPayload = {
			'plinkID': plinkID,
			'type': this.tab,
			// 'fromDate': 0,
			// 'toDate': toDate,
			// 'from': 'MostRecent',
			// 'lastID': lastID
		};
		this.plinksDashboard.fetchPlinkData(faultsPayload).subscribe((response: any) => {
			if(response && response.length > 0) {
				this.FaultsGridData = [...response];
				this.FaultsGridData = this.FaultsGridData.sort((a:any, b:any) => {return b.id - a.id});
			}
			else{
				this.FaultsGridData = [];
			}
			this.isLoading = false;
		});
	}

	isSet(tabId: any) {
		return this.tab === tabId;
	}

	onFaultCellClicked(fault: any) {
		// Handle fault cell click if needed
		console.log('Fault clicked:', fault.node.data);
	}

	ngOnChanges(changes: SimpleChanges) {
		// Trigger API call when either device or date changes
		if ((changes['plink'] && changes['plink'].currentValue)) {
			this.plink = changes['plink'].currentValue;
			this.plinkID = this.plink.deviceid;
			this.getFaultsData();
		}
	}

	ngOnDestroy() {
		if(this.intervalID) {
			clearInterval(this.intervalID);
		}
	}

}
